module.exports = __webpack_public_path__ + "img/logo-5.20c4bcfa.png";